import type { FetchFileCollectionPathResponse } from '@witmetrics/api-client';

export type FileCollectionPath = FetchFileCollectionPathResponse[number];

export const classes = {
  condensedWrapper: 'flex items-center min-w-0 gap-2',
  backButton:
    'shrink-0 -ml-1 p-0.5 rounded text-grey-7 hover:bg-grey-3 transition-colors dark:text-mauve-2 dark:hover:bg-white/10',
  folderIcon: 'shrink-0 text-grey-6 dark:text-mauve-3',
  title: 'truncate',
};
